import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import {
  type FooterSocialLink,
  type FooterSupportButton,
  FooterVariant1,
} from '@workspace/shared/components/FooterVariant1';

import MirLogo from '~/assets/img/dubaiexpress/mir-logo.svg';
import SbpLogo from '~/assets/img/dubaiexpress/sbp-logo.svg';
import { company } from '~/company/Company';
import { CompanyName } from '~/company/interface';
import Icon from '~/components/Icon/Icon';
import type { IconTypes } from '~/components/Icon/IconTypes';
import { TrustBar } from '~/pages/DubaiExpress/components/TrustBar';
import { ROUTES } from '~/pages/Root/constants';

declare global {
  interface Window {
    jivo_api?: { open: () => void };
  }
}

const SOCIAL_LINKS: { link?: string; icon: IconTypes; label: string }[] = [
  // { link: company.config.links.instagram, icon: 'insta', label: 'Instagram' },
  // { link: company.config.links.facebook, icon: 'facebook', label: 'Facebook' },
  // { link: company.config.links.youtube, icon: 'youtube', label: 'YouTube' },
];

const FooterDE = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const isCheckout = pathname === ROUTES.checkout;
  const isDubaiExpress = company.is(CompanyName.DubaiExpress);

  const supportIcon = <Icon type="message_text_circle" />;

  const supportButton: FooterSupportButton | undefined = isDubaiExpress
    ? {
        onClick: () => window.jivo_api?.open(),
        label: t('support'),
        icon: supportIcon,
      }
    : company.config.links.tg
      ? {
          href: company.config.links.tg,
          label: t('support'),
          icon: supportIcon,
        }
      : undefined;

  const socialLinks: FooterSocialLink[] = SOCIAL_LINKS.filter(
    (social) => social.link,
  ).map((social) => ({
    href: social.link as string,
    label: social.label,
    icon: <Icon type={social.icon} size={20} />,
  }));

  return (
    <>
      {isDubaiExpress && <TrustBar variant="footer" flatTop={isCheckout} />}
      <FooterVariant1
        className={isDubaiExpress ? '-mt-4 min-[1025px]:-mt-6' : undefined}
        logo={{
          src: company.images.logo.dark,
          to: '/',
        }}
        menuColumns={[
          {
            title: t('company'),
            mobileGroup: 'row1',
            items: [
              { dataLink: 'footer-about', to: '/about', label: t('aboutUs') },
              {
                dataLink: 'footer-smi',
                to: '/smi',
                label: t('mediaAboutUs'),
              },
              {
                dataLink: 'footer-contacts',
                to: '/contacts',
                label: t('contacts'),
              },
            ],
          },
          {
            title: t('forCustomers'),
            mobileGroup: 'row1',
            items: [
              { dataLink: 'footer-faq', to: '/faq', label: t('faq') },
              {
                dataLink: 'footer-delivery',
                to: '/delivery',
                label: t('delivery'),
              },
            ],
          },
          {
            title: t('information'),
            items: [
              {
                dataLink: 'footer-privacy',
                to: '/legals#privacy-policy',
                label: t('privacyPolicy'),
              },
              {
                dataLink: 'footer-terms',
                to: '/legals#terms-of-service',
                label: t('userAgreement'),
              },
            ],
          },
        ]}
        paymentLogos={company.match({
          dubaiexpress: [
            { src: SbpLogo, alt: 'СБП', width: 93, height: 36 },
            { src: MirLogo, alt: 'МИР', width: 59, height: 34 },
          ],
          default: [],
        })}
        socialLinks={socialLinks}
        copyrightText={t('dubaiExpressCopyright')}
        supportButton={supportButton}
        linkComponent={Link}
        dataTheme={company.name}
      />
    </>
  );
};

export default FooterDE;
